export enum OnlineStatus {
    Online = 'online',
    Away = 'away',
    Offline = 'offline'
}